/******************************************************************************
 * Tween Class
 * version: 1.0.2, release: 11.08.2021
 * author: albert lang, albert@jumptomorrow.com
 * ----------------------------------------------------------------------------
 * description:
 * simplified tween, only with update callback whitout target and prop
 * additive tweener: https://greensock.com/forums/topic/12573-additive-animation/
 * 
 * sample:
 * let t = TweenS.to(100, 1, {from:0, onUpdate:.., onComplete:..})
 * //or
 * let t = new TweenS({from:0, onUpdate:e => {console.log(e.value)}});
 * t.to(100);	//start
 * 
 * dependencies: none
 * 
 * todos:
 * include delay
 * 
 * links:
 * 
 * 
******************************************************************************/



//============================================================================= TweenItem Class
export default class TweenS {
	static tweens = [];


	constructor(param){
		this.clear();

		this.param = param || {};
		this.power = this.param.power || 3;
		this.calcBind = this.calc.bind(this);

		this.last = 0;
		this.duration = this.param.duration || 1;
	}


	clear(){
		this.value = 0;
		this.progress = 1;
		this.tweens = [];
		this.numTweens = 0;
		this.isRunning = false;
		// this.last = 0;		//dont override last value!
	}


	to(next, duration, param){
		if (param) this.param = {...this.param, ...param};

		let from = param?.from ?? this.last ?? 0;
		this.last = next;
		this.param && delete this.param.from;		//'from' can used only once if not explicit setted
		
		if (duration === 0){
			this.clear();
			this.value = next;
			this.param.onUpdate && this.param.onUpdate(this);
			this.param.onComplete && this.param.onComplete(this);
			return;
		}

		this.duration = duration || this.duration || this.param.duration || 1;

		this.tweens.push({		//add tween
			from,
			to		: next,
			// distance: next - from,
			duration: this.duration * 1000,
			time	: 0,		//from 0 to duration
			progress: 0,		//from 0 to 1
			start	: performance.now(),
			ratio	: 0,
			value	: 0,
		});

		this.numTweens ++;
		this.progress = 0;

		if (!this.isRunning){		//start now
			this.isRunning = true;
			this.value = from;
			this.param.onUpdate && this.param.onUpdate(this);
			window.requestAnimationFrame(this.calcBind);
		}
	}


	calc(){
		if (!this.isRunning) return;		//canceled
		let n = performance.now();
		this.value = 0;
		
		this.tweens.forEach((tw, i) => {
			tw.time = n - tw.start;
			if (tw.time >= tw.duration){	//finish
				tw.progress = 1;
				tw.value = tw.to;

			}else{
				tw.progress = tw.time / tw.duration;
				tw.ratio = getRatio(tw.progress, this.power);
				// tw.value = tw.from + tw.distance * tw.ratio;
				tw.value = tw.from + (tw.to - tw.from) * tw.ratio;
			}
			this.value += tw.value;
			if (i < this.numTweens-1) this.value -= tw.to;

			this.progress = tw.progress;
		})

		this.last = this.value;
		
		if (this.tweens[0].progress === 1){
			this.numTweens --;
			this.tweens.shift();		//remove first tween-item
		}

		if (this.param.onUpdate) this.param.onUpdate(this);

		if (this.numTweens){			//tween in progress
			window.requestAnimationFrame(this.calcBind);

		}else{							//all tweens complete
			this.isRunning = false;
			this.param.onComplete && this.param.onComplete(this);
		}
	}
}


const getRatio = (p, pow=3) => {
	let r = Math.pow(p < 0.5? p * 2 : (1 - p) * 2, pow);
	return p < 0.5? r / 2 : 1 - (r / 2);
}
